class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const { recommendationsUrl, productId, sectionId, productLimit } =
      this.dataset;

    const url = `${recommendationsUrl}?section_id=${sectionId}&product_id=${productId}&limit=${productLimit}&intent=related`;
    this.loadProductRecommendations(url);

    this.initScrollReveal()
  }

    initScrollReveal() {
    // Kill any existing observer first
    if (this._scrollObserver) {
      this._scrollObserver.disconnect();
    }

    this._scrollObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            this._scrollObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    this.querySelectorAll(
      ".bosProductGridProduct:not(.is-visible), .bosProductGridEditorialContent:not(.is-visible), .bosProductGridEditorialContentSpanOne:not(.is-visible)",
    ).forEach((el) => this._scrollObserver.observe(el));
  }

  async loadProductRecommendations(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! ${response.status}`);

      const responseHTML = await response.text();

      const html = document.createElement("div");
      html.innerHTML = responseHTML;

      const recommendations = html.querySelector("product-recommendations");
      if (recommendations) {
        this.innerHTML = recommendations.innerHTML;
      }
    } catch (err) {
      console.error(err);
    }
  }
}

if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}
